//requires: public\pclm-events-manager.js

// pclm-map-helper.js

jQuery(function($) {
	$(document).ready(function(){
		mapsManager.init();
		
		mapsManager.initAllMaps();

	    $("#contextual-help-link").click(function () {
	        $("#contextual-help-wrap").css("cssText", "display: block !important;");
	    });
	    $("#show-settings-link").click(function () {
	        $("#screen-options-wrap").css("cssText", "display: block !important;");
	    });
	});
});

var mapsManager ={

	_that: undefined,
	_properties:{},
	_mapsList:{},
	_drawManagers:[],
	readyEvent:  undefined,
	_eventManager: eventManager,

	init: function(){
		mapsManager._that= this;
		mapsManager.readyEvent = new CustomEvent('ready');
		this.get_map_id_prefix();
	},


	registerForEvents : function(element){
		mapsManager._eventManager.register(element);
	},

	initMap: function (mapId, mapData){


		var basics_data = {};
		
		
		// handle map height
		if ((mapData["height"]) && (jQuery("#"+mapId).height()!=400)){
			
			var ww = jQuery(window).width();
			var idxSize = 0;
			var mapHeightUnit = 'px';
			var mapHeight=400;
			
			if (ww <768){
				idxSize=0
			}else if ((ww > 768) && (ww < 992)){
				idxSize=1;
			}else if ((ww > 992) && (ww < 1200)){
				idxSize=2
			}else{
				idxSize = 3;
			}
			
			if ( mapData["height"]['size']){
				mapHeight = mapData["height"]['size'][idxSize];
	
				switch (mapData["height"]['unit'][idxSize]) {
				case 'px':
					mapHeightUnit = 'px';
					break;
				case 'pc':
					mapHeightUnit = '%';
					break;
	
				default:
					mapHeightUnit = 'px';
				}
			}else{
				mapHeight = mapData["height"][idxSize];
			}
			
			
			jQuery("#"+mapId).height(mapHeight+mapHeightUnit);
		}else{
			jQuery("#"+mapId).height(400);
		}

		

		
		
		// prepare map options
 		var mapOptions = mapData["map_options"];
 		var layersControlDisplay = false;
 		var tileLayersData = undefined;
 		
 		for( var mapProp in mapOptions){
 			var optionName  = mapOptions[mapProp]['name'];
 			var optionValue = mapOptions[mapProp]['values'];
 		
 			if (optionName){
	 			switch(optionName){
	 			case "center":
	 			case "maxBounds":{
	 				optionValue = JSON.parse(optionValue);
	
	 				break;
	 			}
	 			default:
	 				{
	 				
	 				}
	 			}	
	 			basics_data[optionName]= optionValue;
	 		}else if (mapOptions[mapProp] == 'layers_control_display'){
	 			layersControlDisplay = true;
	 		}
 		}
 			
 	
 		if(!basics_data["center"]){
 			basics_data["center"]=L.latLng(0, 0);
 		}
 		
 		if (!basics_data["zoom"]){
 			basics_data["zoom"]=0;
 		}
 		
 		var mymap = L.map(mapId,basics_data);
	 		
 		if (!mymap || mymap == null){return false;}
 		mapsManager._that._mapsList[mapId]=mymap;
 		
 		if (mapData["tileLayers"]){tileLayersData = mapData["tileLayers"]}else{tileLayersData=null;}
 		
		tileLayersManager.initAllTileLayers(mapId,tileLayersData, layersControlDisplay);
		
		void 0

	},

	initAllMaps: function (){

		/*Récupération des Id de carte*/
		var _map_id_prefix = mapsManager._that._properties['map_id_prefix'];

		/*recherche des emplacements de cartes sur la page*/
		var map_spots = mapsManager._that.searchMapOnPage(_map_id_prefix);

		/*Initialisation des cartes*/
		 map_spots.each(function(i,v) {
			 
			 var context={};
			 context['idx'] = i;
			 context['length'] = map_spots.length;
			 
			 mapsManager.initModal(this.id);
			 
			jQuery.get(ajax_object.ajaxurl,
				{	
					"action":"map_data",
					"id":this.id,
					"context": context
				},
				function(data){

					mapsManager._that.initMap(data.id,data.data);
					
					
					
					// after the last map init inform others manager to init
					if (!(data.context.idx < data.context.length-1)){
						mapsManager._eventManager.fireEvent(mapsManager.readyEvent);
					}
					
					
				},
				"json"
			);	
		});
	},

	searchMapOnPage: function(map_id_prefix){
		return jQuery("[id|="+map_id_prefix+"]");
	},

	get_map_id_prefix: function(){

		return this._properties['map_id_prefix'] = init_values.map_id_prefix;

	},
	
	getMapsId: function(){
		return jQuery("[id|="+ this._properties['map_id_prefix'] +"]");
	},
	
	getMapHtmlId: function(mapId){
		if (!(typeof mapId === 'string')){
			mapId = mapId.toString();
		}
		var mapHtmlId = false;
		
		if (-1 != mapId.indexOf(this.get_map_id_prefix()) ){
			mapHtmlId = mapId;
		}else{
			mapHtmlId = mapsManager.get_map_id_prefix()+'-'+mapId;
		}
		
		return mapHtmlId;
	},

	getMapElt: function(mapId){

		var eltToReturn = false;
		
		if (mapsManager._mapsList.hasOwnProperty(mapId)){
			eltToReturn = mapsManager._mapsList[mapId];
		}
		else if (mapsManager._mapsList.hasOwnProperty(this._properties['map_id_prefix']+"-"+mapId)){
			eltToReturn = mapsManager._mapsList[this._properties['map_id_prefix']+"-"+mapId];
		}else{
			eltToReturn = false;
		}
		return eltToReturn;
	},
	
	

	setDrawCapabilities: function(drawManager){
		if (drawManager){
			for (var map in mapsManager._mapsList){ 
				mapsManager._drawManagers[map]=drawManager;
				L.Util.setOptions(mapsManager._mapsList[map],{drawControl: true});
			}
		}else{
			return false;
		}
	},

	unsetDrawCapabilities: function(drawManager){
		
		for (var map in mapsManager._mapsList){ 
			if (!drawManager || mapsManager._drawManagers[map] == drawManager){
				L.Util.setOptions(mapsManager._mapsList[map],{drawControl: false});
				mapsManager._drawManagers.splice(mapsManager._drawManagers.indexOf(map), 1);
			}
		}

	},
	
	checkDrawCapabilities: function(mapId){
		return mapsManager._mapsList[mapId];
	},
	

	
	setLayer: function(mapId, layer){
		var mapElt = mapsManager.getMapElt(mapId);
		if (mapElt){
			return mapElt.addLayer(layer);
		}else{
			return false;
		}
	},
	
	setControl: function(mapId, control){
		var mapElt = mapsManager.getMapElt(mapId);
		if (mapElt){
			return mapElt.addControl(control);
		}else{
			return false;
		}
	},
	initModal: function(mapId){	
		
		//jQuery('<div id="marker-info-'+mapId+'" ></div>').insertAfter(jQuery("#"+mapId));

	}
};


/* Event Polyfill for IE*/
(function () {

	  if ( typeof window.CustomEvent === "function" ) return false;

	  function CustomEvent ( event, params ) {
	    params = params || { bubbles: false, cancelable: false, detail: undefined };
	    var evt = document.createEvent( 'CustomEvent' );
	    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	    return evt;
	   }

	  CustomEvent.prototype = window.Event.prototype;

	  window.CustomEvent = CustomEvent;
	}

)();

if (L.Browser.ie ) {
	Object.keys = function(obj) {
	    var keys = [];
	
	    for (var i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        keys.push(i);
	      }
	    }
	
	    return keys;
	  };
}

